export enum EStatusTarefaSegundoPlano {
    EmAberto = 1,
    EmAndamento = 2,
    Concluida = 3,
    Malsucedida = 4
}
